import { createReducer, on } from '@ngrx/store';
import { initialState } from '../auth.state';

import * as actions from './recovery.actions';
import { RecoveryFlowState } from '@ory/client';

export const authRecoveryReducer = createReducer(
  initialState,

  on(actions.ClearRecoveryFlow, (state) => ({
    ...state,
    loading: false,
    error: null,
    accountRecoveryFlow: null,
  })),

  on(actions.RequestBeginAccountRecovery, (state) => ({ ...state, loading: true })),

  on(actions.SuccessBeginAccountRecovery, (state, { flow }) => ({
    ...state,
    loading: false,
    accountRecoveryFlow: flow,
  })),

  on(actions.RequestCompleteAccountRecovery, (state) => ({ ...state, loading: true })),

  on(actions.FailCompleteAccountRecovery, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(actions.SuccessCompleteAccountRecovery, (state, { passwordChangeFlowId }) => ({
    ...state,
    loading: false,
    error: null,
    accountRecoveryFlow: {
      ...state.accountRecoveryFlow,
      state: RecoveryFlowState.PassedChallenge,
    },
    passwordChangeFlowId: passwordChangeFlowId,
  }))
);
